import React from "react";

export default function CoachsSection({ photoMoub, photoSaber, onOpenLightbox }) {
  return (
	<section id="coachs" className="section">
	  <div className="container">
		<span className="section-label">🥋 Encadrement</span>
		<h2 className="section-title">Nos Coachs</h2>
		<p className="section-sub">Des entraîneurs diplômés Adeps, passionnés et investis à 100%.</p>

		<ul className="coach-grid">
		  <li
			className="coach-card"
			onClick={() => onOpenLightbox(photoMoub)}
			aria-label="Voir Coach Moubarak"
		  >
			<img src={photoMoub} alt="Moubarak — Head Coach Adultes" loading="lazy" />
			<div className="coach-info">
			  <h3>Moubarak</h3>
			  <p>Head Coach – Adultes</p>
			  <p>Entraîneur Compétition</p>
			  <span className="coach-belt">🥋 Diplômé Adeps</span>
			</div>
		  </li>

		  <li
			className="coach-card"
			onClick={() => onOpenLightbox(photoSaber)}
			aria-label="Voir Coach Saber"
		  >
			<img src={photoSaber} alt="Coach Saber" loading="lazy" />
			<div className="coach-info">
			  <h3>Saber</h3>
			  <p>Head Coach – Enfants</p>
			  <p>Entraîneur Technique</p>
			  <span className="coach-belt">🥋 Diplômé Adeps</span>
			</div>
		  </li>
		</ul>
	  </div>
	</section>
  );
}
